"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeClass = TypeClass;
exports.typeClassKey = void 0;

/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 31/10/2021
 */
var typeClassKey = "type:class:discriminator-options";
exports.typeClassKey = typeClassKey;

function TypeClass() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (target, propertyKey) {
    // console.log("TypeClass: target = ", target, ", propertyKey = ", propertyKey)
    setTimeout(function () {
      options.discriminator.subTypes = options.discriminator.subTypes.map(function (item) {
        item.value = item.value();
        return item;
      });
      Reflect.defineMetadata(typeClassKey, {
        options: options
      }, target, propertyKey);
    });
  };
}